import * as firebase from 'firebase/app'
import 'firebase/auth'
import { loginToFacebook } from 'services/facebook'
import config from 'config'

let beforeUserLogoutCallback = () => Promise.resolve()

export const initialize = (
  onUserLogin: (user: firebase.User) => any, // tslint:disable-line:no-any
  onUserLogout: () => any, // tslint:disable-line:no-any
  beforeUserLogout?: () => Promise<void>,
) => {
  firebase.initializeApp({
    apiKey: config.FIREBASE_API_KEY,
    projectId: config.FIREBASE_PROJECT_ID,
    authDomain: config.FIREBASE_AUTH_DOMAIN,
    databaseURL: config.FIREBASE_DATABASE_URL,
  })

  firebase.auth()
    .onAuthStateChanged((user: firebase.User | null) => {
      if (user) {
        onUserLogin(user)
      } else {
        onUserLogout()
      }
    })

  if (beforeUserLogout) {
    beforeUserLogoutCallback = beforeUserLogout
  }
}

export const getIdToken = () => {
  const user = firebase.auth().currentUser
  return user ? user.getIdToken() : Promise.reject(new Error('Cannot get token of an empty Firebase user.'))
}

export const loginWithFacebook = async () => {
  const facebookAccessToken = await loginToFacebook()
  const credential = firebase.auth.FacebookAuthProvider.credential(facebookAccessToken)

  return firebase.auth().signInWithCredential(credential)
}

export const logout = async () => {
  await beforeUserLogoutCallback()
  return firebase.auth().signOut()
}
